var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrompt = function SvgPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#prompt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.335 5c-3.143 0-4.714 0-5.69.976-.977.977-.977 2.548-.977 5.69s0 4.715.976 5.691c.977.976 2.548.976 5.69.976h3.334c3.143 0 4.714 0 5.69-.976.977-.976.977-2.548.977-5.69 0-.975 0-1.799-.03-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.001 1.667.246.664c.322.87.483 1.306.8 1.623.318.318.753.479 1.624.8l.664.246-.664.246c-.87.322-1.306.483-1.623.8-.318.318-.479.753-.801 1.624l-.246.664-.245-.664c-.322-.87-.483-1.306-.801-1.623-.318-.318-.753-.479-1.623-.801L11.668 5l.664-.245c.87-.322 1.305-.483 1.623-.801.318-.317.479-.753.8-1.623z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prompt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPrompt;